export type AnnouncementState = 'staged' | 'approved' | 'recorded' | 'historical' | 'duplicate' | 'conflict' | 'rejected' | 'legacy-accepted' | 'legacy-unknown' | 'open';
export interface AnnouncementDecision {
  id: string; symbol: string; exDate: string; type: string; source: string;
  before: string; status: AnnouncementState; reason: string; canonicalId?: string;
  matchedDividendIds: string[]; missingSubfolioIds: string[]; changed: boolean;
}
export interface AnnouncementPreview {
  cutoverPending?: boolean; cutoffDate?: string; openingCounts?: { accepted: number; open: number; unknown: number };
  fingerprint: string; asOf: string; total: number; changes: number;
  counts: Record<AnnouncementState, number>; rows: AnnouncementDecision[];
}
export const announcementLabels: Record<AnnouncementState, string> = {
  'legacy-accepted': 'Historical — accepted at import', 'legacy-unknown': 'Legacy payment status unknown', open: 'Open at import',
  staged: 'Awaiting processing', approved: 'Ready to process', recorded: 'Already recorded', historical: 'No eligible holding',
  duplicate: 'Duplicate source', conflict: 'Needs attention', rejected: 'Rejected',
};
